import { SYSTEM_LOGS_LIST } from "./types";

export const systemLogsList = (data, onSuccess, onError) => {
    return {
        type: SYSTEM_LOGS_LIST,
        data,
        onSuccess,
        onError,
    };
};
